import React, { useState, useEffect } from "react";
import { HeaderComponent, TableComponent, BodyComponent, ActionComponent, trans, Switch, ButtonComponent } from '@comps/components';
import { makeRequest } from '@utils/helpers';
import { getCaseStatussReq, changeStatusReq, deleteCaseStatusReq } from './requests';
import { updateById, deleteById } from '@comps/commonFunctions';
import CreateCaseStatus from "./components/CreateCaseStatus";
import UpdateCaseStatus from "./components/UpdateCaseStatus";
import toast from "@comps/toast";
const pageConfig = {
  headers: {
    title: "Case Status",
    breadcrumb: [
      {
        name: "Case Status",
        path: "/case-management/statuses"
      }
    ]
  }
}

const IndexCaseStatus = () => {
  const [dataSource, setDataSource] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
  });

  useEffect(() => {
    getCaseStatussData();
  }, [pagination]); // eslint-disable-line react-hooks/exhaustive-deps

  const getCaseStatussData = () => {
    makeRequest(setLoader, getCaseStatussReq, null, onSuccess, onError);
  }

  const onError = (error) => {
    console.log(error);
  }

  const onSuccess = (data) => {
    setDataSource(data.data);
    setTotalRecords(data.totalRecords);
  }

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || 'id',
      sortStatus: sorter.order === 'ascend' ? 'asc' : 'desc',
    };
    setPagination(payload);
  }


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
    },
    {
      title: "Active",
      render: (data) => {
        return (
          <Switch onChange={ (action) => onChangeStatus(data, action) } checked={ data.is_active } />
        )
      }
    },
    {
      title: trans(`common.actions`),
      render: (record) => <ActionComponent each={ record } onEdit={ onEdit } onDelete={ onDelete } >
      </ActionComponent>
    },
  ];


  const onChangeStatus = (data, action) => {
    let payload = {
      id: data.id,
      status: action
    };
    makeRequest(setLoader, changeStatusReq, payload, onChangeStatusSuccess, onChangeStatusError);
  }

  const onChangeStatusSuccess = (data, res) => {
    let index = dataSource.findIndex(each => each.id === data.id);
    dataSource[index].is_active = data.is_active;
    setDataSource([...dataSource]);
    toast.success(res.msg);
  }

  const onChangeStatusError = (error) => {
    console.log(error);
  }

  const onCreate = () => {
    setChildComponent(<CreateCaseStatus onCreated={ onCreated } onClosed={ onClosed } />);
  }

  const onCreated = (data) => {
    setDataSource([data, ...dataSource]);
    setChildComponent(null);
  }


  const onEdit = (record) => {
    setChildComponent(<UpdateCaseStatus data={ record } onUpdated={ onUpdated } onClosed={ onClosed } />);
  }

  const onUpdated = (data) => {
    setDataSource([...updateById(dataSource, data)]);
    setChildComponent(null);
  }

  const onDelete = (record) => {
    makeRequest(setLoader, deleteCaseStatusReq, record.id, onDeleteSuccess, Function);
  }

  const onDeleteSuccess = (data) => {
    setDataSource([...deleteById(dataSource, data)]);
  }

  const onClosed = () => {
    setChildComponent(null);
  }

  return (
    <>
      { childComponent }
      <HeaderComponent headers={ pageConfig.headers } description="The states a case can move through." />
      <BodyComponent flush onCreate={ onCreate }>
        <TableComponent loader={ loader } columns={ columns } dataSource={ dataSource } emptyState={ { icon: "tabler:progress", title: "No statuses yet", description: "Add a status to define how cases progress." } } pagination={ { ...pagination, total: totalRecords } } onChange={ handleTableChange } />
      </BodyComponent>
    </>
  )

}

export default IndexCaseStatus